module.exports = "/fonts/vendor/@mdi/materialdesignicons-webfont.eot?5d6f62d26868981998c04102e29046cb";